import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SvgElement = styled.svg`
  width: ${props => props.width};
  height: ${props => props.height};
  padding: 0;
  cursor: ${props => (props.onClick ? 'pointer' : 'initial')};
`

const Svg = props => {
  const { onClick, className, config } = props
  const {
    viewBox,
    width,
    height,
    paths,
    polylines,
    rects,
    fill,
    stroke,
    strokeWidth,
    strokeLinecap,
    strokeLinejoin,
  } = config
  const pathElements = paths
    ? paths.map(({ path, color, transform }, i) => (
        <path key={i} fill={color} d={path} transform={transform} />
      ))
    : null
  const polylineElements = polylines
    ? polylines.map((points, i) => <polyline key={i} points={points} />)
    : null
  const rectElements = rects
    ? rects.map(
        (
          {
            x: _x,
            y: _y,
            width: _width,
            height: _height,
            stroke: _stroke,
            strokeWidth: _strokeWidth,
            strokeLinecap: _strokeLinecap,
            strokeLinejoin: _strokeLinejoin,
          },
          i
        ) => (
          <rect
            key={i}
            x={_x}
            y={_y}
            width={_width}
            height={_height}
            stroke={_stroke}
            strokeWidth={_strokeWidth}
            strokeLinecap={_strokeLinecap}
            strokeLinejoin={_strokeLinejoin}
          />
        )
      )
    : null

  return (
    <SvgElement
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
    >
      {pathElements}
      {polylineElements}
      {rectElements}
    </SvgElement>
  )
}

Svg.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  config: PropTypes.object, // eslint-disable-line
}

export default Svg
